<ng-container *ngIf="featureReady">
  <app-reason-list-v2 *ngIf="useV2"></app-reason-list-v2>
  <app-reason-list *ngIf="!useV2"></app-reason-list>
</ng-container>
